import { render, staticRenderFns } from "./DoubleRefractionViz.vue?vue&type=template&id=76f5214c&scoped=true"
import script from "./DoubleRefractionViz.vue?vue&type=script&lang=js"
export * from "./DoubleRefractionViz.vue?vue&type=script&lang=js"
import style0 from "./DoubleRefractionViz.vue?vue&type=style&index=0&id=76f5214c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5214c",
  null
  
)

export default component.exports